import { render, staticRenderFns } from "./ResponseByQuestions.vue?vue&type=template&id=1f4b9b52"
import script from "./ResponseByQuestions.vue?vue&type=script&lang=js"
export * from "./ResponseByQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports